<template>
  <div
    class="fou-bundle-input-wrap"
    :class="[{ 'mt-input--error': Object.hasOwn(errors, 'part number') }]"
  >
    <TextField
      id="part-number"
      v-model="partNumber"
      placeholder=" "
      data-qa-id="part-number"
      rules="script_tag_validate"
      name="part number"
      :input-class="[{ 'mt-input--error': Object.hasOwn(errors, 'part number') || !isBundleNameUnique }]"
      :show-error-message="false"
      emit-blur
      @blur="updatePartNumber()"
    />
    <label
      class="fou-bundle-input-placeholder"
      for="part-number"
    > {{ $t('pages.bundle.draft.part_number') }}</label>
  </div>
  <div
    v-if="Object.hasOwn(errors, 'part number')"
    class="ml-0 mt-error"
    data-qa-id="part-number-error"
  >
    {{ errors['part number'] }}
  </div>
</template>

<script src="./index.js" />
